module.exports = __webpack_public_path__ + "img/rating1.5a43d38a.png";